import { Link } from "react-router-dom";
import { mediaList } from "@/mocks/media";
import { useViewHistory } from "@/hooks/useLocalLibrary";

export default function RecentHistory() {
  const { history, clearHistory } = useViewHistory();
  const items = history
    .map((id) => mediaList.find((item) => item.id === id))
    .filter((item): item is (typeof mediaList)[number] => Boolean(item));

  if (items.length === 0) return null;

  return (
    <section className="py-8 md:py-10">
      <div className="mb-4 flex items-center justify-between gap-4">
        <div className="flex items-center gap-2.5">
          <span className="flex h-7 w-7 items-center justify-center rounded-md bg-secondary-100 text-secondary-700">
            <i className="ri-history-line text-base" />
          </span>
          <h2 className="font-heading text-base font-semibold text-foreground-950">最近浏览</h2>
          <span className="rounded-full bg-background-100 px-2 py-0.5 text-[11px] text-foreground-500">
            {items.length} 部
          </span>
        </div>
        <button
          type="button"
          onClick={clearHistory}
          className="cursor-pointer whitespace-nowrap text-xs text-foreground-500 transition-colors hover:text-primary-700"
        >
          清空记录
        </button>
      </div>
      <div className="no-scrollbar flex gap-3 overflow-x-auto pb-1">
        {items.map((item) => (
          <Link
            key={item.id}
            to={`/detail/${item.id}`}
            className="group flex w-[236px] shrink-0 cursor-pointer items-center gap-3 rounded-lg border border-background-200/80 bg-background-50 p-2.5 transition-colors hover:border-primary-300"
          >
            <div className="h-[72px] w-[54px] shrink-0 overflow-hidden rounded-md bg-background-200">
              <img
                src={item.cover}
                alt={`${item.title} 封面`}
                title={`${item.title} - 最近浏览`}
                className="h-full w-full object-cover object-top"
              />
            </div>
            <div className="min-w-0">
              <p className="truncate text-[13px] font-medium text-foreground-900 group-hover:text-primary-700">
                {item.title}
              </p>
              <p className="mt-1 text-[11px] text-foreground-500">
                {item.year} · {item.region}
              </p>
              <p className="mt-0.5 flex items-center gap-1 text-[11px] text-accent-700">
                <i className="ri-star-fill text-[10px]" />
                {item.rating.toFixed(1)}
              </p>
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
}